module.exports = __webpack_public_path__ + "static/media/artichokes_petrale_sole.024f148e.png";